import { SelectFuncionarios } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { reps } from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'

const schema = z.object({
    funcionarioIds: z
        .array(z.number())
        .min(1, 'Selecione ao menos um funcionário'),
})

interface Props {
    repId: number
    /** Já vinculados: aparecem marcados e travados no select. */
    funcionarioIdsAssociados: number[]
    open: boolean
    onClose: () => void
}

/** Associa vários funcionários ao REP; cada um é enviado ao equipamento pela API. */
export function AdicionarFuncionariosRep({
    repId,
    funcionarioIdsAssociados,
    open,
    onClose,
}: Props) {
    const { mutateAsync, isLoading } = reps.funcionarios.mutations.useCreate({
        invalidateQuery: true,
    })

    async function handleSubmit({ funcionarioIds }: z.infer<typeof schema>) {
        // a API associa um por vez; allSettled para uma falha não esconder os demais
        const resultados = await Promise.allSettled(
            funcionarioIds.map(funcionarioId =>
                mutateAsync({ funcionarioId, repId }),
            ),
        )
        const falhas = resultados.filter(
            ({ status }) => status === 'rejected',
        ).length
        const sucessos = resultados.length - falhas

        if (sucessos)
            toast.success(`${sucessos} funcionário(s) associado(s) com sucesso`)
        if (falhas) {
            toast.error(`${falhas} funcionário(s) não puderam ser associados`)
            if (!sucessos) throw new Error('Nenhum funcionário associado')
        }
    }

    return (
        <Dialog.Root
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={schema}
        >
            <Dialog.Title>Associar funcionários</Dialog.Title>
            <Dialog.Content>
                <SelectFuncionarios form checked={funcionarioIdsAssociados} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
